import { TaskStatusType, TaskType, WorkflowTaskReferenceKeyType } from "../../__generated__/generated_types";
import { TUserWorkflow, TUserWorkflowTask } from "./logic/useUserWorkflow";


export const workflowRevenueScreenMap: Map<WorkflowTaskReferenceKeyType, string> = new Map([
    [WorkflowTaskReferenceKeyType.AvgMarketRents, "/operational/average-rent/reforecast/"],
    [WorkflowTaskReferenceKeyType.EarlyTerms, "/operational/early-terminations/reforecast/"],
    [WorkflowTaskReferenceKeyType.Expirations, "/operational/lease-expirations/reforecast/"],
    [WorkflowTaskReferenceKeyType.MonthToMonth, "/operational/month-to-month-move-outs/reforecast/"],
    [WorkflowTaskReferenceKeyType.MoveOuts, "/operational/move-outs/reforecast/"],
    [WorkflowTaskReferenceKeyType.Occupancy, "/operational/occupancy-rates/reforecast/"],
    [WorkflowTaskReferenceKeyType.RenewalsRate, "/operational/renewal-rates/reforecast/"],
    [WorkflowTaskReferenceKeyType.RenewalsRatio, "/operational/renewal-ratios/reforecast/"],
    [WorkflowTaskReferenceKeyType.OccupancyManager, "/operational/occupancy-manager/reforecast/"],
    [WorkflowTaskReferenceKeyType.Payroll, "/payroll/"],
    [WorkflowTaskReferenceKeyType.ExecutiveSummary, "/property_executive_summary/"],
]);

export function getExitWorkflowRoute(task: TUserWorkflowTask): string {
    switch (task.taskType) {
        case TaskType.Account:
            return `/account/${task.accountId}/reforecast`;
        case TaskType.Revenue:
            if (task.referenceKey) {
                return workflowRevenueScreenMap.get(task.referenceKey) ?? "";
            } else {
                return "";
            }
        case TaskType.Custom:
            if (task.referenceKey) {
                return workflowRevenueScreenMap.get(task.referenceKey) ?? "";
            } else {
                return "";
            }
        default:
            return "";
    }
}

export function workflowTaskToResume(workflow: TUserWorkflow): TUserWorkflowTask | undefined {
    const firstUnfinishedTask = workflow.tasks.find(task => !task.currentStatus || task.currentStatus.status == TaskStatusType.Pending);
    const lastTask = workflow.tasks[workflow.tasks.length - 1];

    return firstUnfinishedTask ?? lastTask;
}
